module.exports = __webpack_public_path__ + "img/icon-zysf.fdff52fc.png";